<template>
  <div
    v-if="parseInt(discount, 10) > 0"
    :style="{
      color,
      borderColor: border ? fill : 'transparent',
      background: border ? 'transparent' : fill,
    }"
    :class="{ border, fill: !border }"
    class="calculator__flag">
    -{{ discount }}%
  </div>
</template>

<script>
export default {
  props: {
    discount: {
      type: [String, Number],
      default: 0,
    },
    color: {
      type: String,
      default: 'white',
    },
    fill: {
      type: String,
      default: 'transparent',
    },
    border: {
      type: Boolean,
      defailt: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.calculator__flag {
  height: 30px;
  position: relative;
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  padding: 0 15px 0 5px;
  border: 3px solid;
  border-right: none;
  font-weight: 600;

  &:before,
  &:after {
    content: '';
    position: absolute;
  }

  &.border {
    &:after {
      top: -3px;
      right: -2px;
      transform: skew(-40deg);
      border-top: 3px solid;
      border-right: 4px solid;
    }

    &:before {
      bottom: -3px;
      right: -2px;
      transform: skew(40deg);
      border-bottom: 3px solid;
      border-right: 4px solid;
    }

    &:before,
    &:after {
      width: 10px;
      height: 15px;
      border-color: inherit;
    }
  }

  &.fill {
    &:after {
      top: -3px;
      right: -1px;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 8px solid #fff;
      border-top: 15px solid transparent;
      border-bottom: 15px solid transparent;
    }
  }
}
</style>
